document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".c-imgtabs__wrapper");
  if (!wrapper) return;

  const mains = wrapper.querySelectorAll(".c-imgtabs__main-collection");
  const buttons = wrapper.querySelectorAll(".c-imgtabs__item");

  function showImage(loop) {
    mains.forEach(fig => fig.classList.remove("is-active"));
    buttons.forEach(btn => btn.classList.remove("is-active"));

    const activeMain = wrapper.querySelector(`.c-imgtabs__main-collection[data-loop="${loop}"]`);
    const activeBtn = wrapper.querySelector(`.c-imgtabs__item[data-loop="${loop}"]`);

    if (activeMain) activeMain.classList.add("is-active");
    if (activeBtn) activeBtn.classList.add("is-active");
  }

  buttons.forEach(btn => {
    btn.addEventListener("click", () => {
      const loop = btn.dataset.loop;
      showImage(loop);
    });
  });

  showImage(1);
});
